export interface FeedbackSuccessViewProps {
  kind: 'bug' | 'feedback';
}

export function FeedbackSuccessView({ kind }: FeedbackSuccessViewProps) {
  const title = kind === 'bug' ? 'Bug report submitted' : 'Feedback submitted';
  const message =
    kind === 'bug'
      ? "Thank you for helping us improve. We'll look into this."
      : 'Thank you for your input. We appreciate your feedback.';

  return (
    <div className="site-support-success">
      <div className="site-support-success__icon" aria-hidden>
        ✓
      </div>
      <div className="site-support-success__title">{title}</div>
      <div className="site-support-success__message">{message}</div>
    </div>
  );
}
